import AllRoutes from "./pages/AllRoutes";
import { ToastContainer, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import 'react-loading-skeleton/dist/skeleton.css'

function App() {
  return (
    <div className="page">
      <div className="page_main">
      <ToastContainer transition={Slide} autoClose={1500} stacked />
        <AllRoutes />
      </div>
    </div>
  );
}

export default App;
